import List from './list/RaceListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})